export default function PHP_setrawcookie() {
  return (
    <div>
      <h1>PHP_setrawcookie</h1>
    </div>
  );
}
